import { Grid, Paper } from "@mui/material";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { compose } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import { ButtonCompo } from "../../components/Comman/Button";
import { LabelCompo } from "../../components/Comman/Label";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { TextFieldCompo } from "../../components/Comman/TextFieldCompo";
import DynamicDetails from "../../components/dynamicscreens/DynamicDetails";
import DynamicFormWithoutValidation from "../../components/dynamicscreens/DynamicFormWithoutValidation";
import { withRouter } from "../../components/withRouter";
import { titleColor } from "../../config/ColorObj";
import endpoint from "../../config/endpoints";
import {
    atleastOne,
    creditLimitMsg,
    noInternetMsg,
    saveFailedMsg,
    savemsg,
    serverMsg,
    updateData
} from "../../config/messageconstant";
import { mandatoryCheck, ValidationCheck } from "../../config/ValidationCheck";
import { ApprovePendingOrderJson } from "../../DynamicFormsJson/MastersJSON/ApprovePendingOrder";
import {
    setCategoryAndItem,
} from "../../Slice/category.slice";
import {
    getPlaceOrderHeaderById,
    setOrderList,
} from "../../Slice/OrderHeaderList.slice";
import { getCreditLimitByStockHolderId } from "../../Slice/StackHolder.slice";
import { apiGet, apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import EditOrderPopUp from "./EditOrderPopUp";
import OrderTable from "./OrderTable";
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
class ApprovalPendingOrderEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: "",
            formErrors: {},
            fieldData: {},
            DataToSet: [],
            value: 0,
            total: 0,
            remark: "",
            totalAmt: 0,
            creditLimit: 0,
            open: false,
            orderList: [],
            qty: 0,
            flag: false,
        };
    }
    setCatList = ({ row }) => {
        const { setCategoryAndItem } = this.props;
        let dataTotal = 0;
        let qtyTotal = 0;
        row.map((rowData) => {
            if (rowData.flag == 3) {
                rowData.productWithMarginAndMrps.map((productData) => {
                    dataTotal = dataTotal + +productData.total;
                    qtyTotal = qtyTotal + +productData.qty;
                });
            }
        });
        const { fieldData } = this.state;
        this.setState({
            total: dataTotal,
            qty: qtyTotal,
        });
        setCategoryAndItem({ row });
    };


    async componentDidMount() {
        const {
            showLoador,
            showNotification,
            getPlaceOrderHeaderById,
        } = this.props;
        if (navigator.onLine) {
            const stockCalAtBill = localStorage.getItem("stockCalAtBill");

            this.setState({
                flag: stockCalAtBill === "1" ? true : false,
            });


            showLoador({ loador: true });

            await getPlaceOrderHeaderById({
                orderHeaderId: this.props.params.id,
            }).then(({ response, success }) => {
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                } else {
                    this.getData(response);
                    this.setState({
                        headerData: response,
                        remark: response.remark !== null ? response.remark : "",
                    });

                }
            });
            showLoador({ loador: false });

        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }



    getData = async (editData) => {
        const { showLoador, showNotification, getCreditLimitByStockHolderId } =
            this.props;

        if (navigator.onLine) {
            this.setState({
                stockStakeHolderId: editData?.fromOrder,
            });

            if (editData?.fromOrder && editData?.fromOrder != "") {
                showLoador({ loador: true });
                await getCreditLimitByStockHolderId({ stockStakeHolderId: editData?.fromOrder }).then(
                    ({ response, success }) => {
                        console.log(response);
                        if (!success) {
                            showNotification({
                                msg: creditLimitMsg,
                                severity: "error",
                            });
                        } else {

                            let totalQty = 0;
                            editData.stockStakeHolderOrderDetails.length !== 0 &&
                                editData.stockStakeHolderOrderDetails.map((orderDetailsObject) => {
                                    totalQty = totalQty + orderDetailsObject.qty;
                                });
                            this.setState({
                                creditLimit:
                                    response.creditLimit !== null ? response.creditLimit : 0,
                                DataToSet: [
                                    {
                                        xs: 12,
                                        sm: 6,
                                        md: 6,
                                        lg: 6,
                                        label: "Order Date",
                                        value: dayjs().format("DD-MM-YYYY"),
                                    },
                                    {
                                        xs: 12,
                                        sm: 6,
                                        md: 6,
                                        lg: 6,
                                        label: "Credit Limit",
                                        value:
                                            response.creditLimit !== null ? response.creditLimit : 0,
                                    },
                                    {
                                        xs: 12,
                                        sm: 6,
                                        md: 6,
                                        lg: 6,
                                        label: "Order Number",
                                        value: editData.orderNo !== null ? editData.orderNo : "",
                                    },
                                    {
                                        xs: 12,
                                        sm: 6,
                                        md: 6,
                                        lg: 6,
                                        label: "Order Date",
                                        value: editData.orderDate !== null ? editData.orderDate : "",
                                    },
                                    {
                                        xs: 12,
                                        sm: 6,
                                        md: 6,
                                        lg: 6,
                                        label: "Taxable Amount",
                                        value: editData.taxableAmt !== null ? editData.taxableAmt : "",
                                    },
                                    {
                                        xs: 12,
                                        sm: 6,
                                        md: 6,
                                        lg: 6,
                                        label: "Total Amount",
                                        value: editData.totalAmt !== null ? editData.totalAmt : "",
                                    },

                                    {
                                        xs: 12,
                                        sm: 6,
                                        md: 6,
                                        lg: 6,
                                        label: "Total Quantity",
                                        value: totalQty,
                                    },
                                ],
                            });
                        }
                    }
                );

                let stockHolderTypeId = localStorage.getItem("dealerTypeId");

                await apiGet({
                    url:
                        endpoint.category +
                        "/items-with-margin-and-mrp-and-stock-by-stock-stake-holder?stockSakeHolderTypeId=" +
                        stockHolderTypeId +
                        "&stockStakeHolderId=" +
                        editData?.fromOrder,
                }).then(({ data, success }) => {

                    if (success && data.data != null) {
                        const rowData = data.data;
                        if (rowData.errorMessage.error) {
                            showNotification({
                                msg: rowData.errorMessage.message,
                                severity: "error",
                            });
                        } else {
                            const row = rowData.categoryAndItems.map((rowObj) => {
                                return {
                                    ...rowObj,
                                    total: 0,
                                    qty: 0,
                                    productWithMarginAndMrps: rowObj.productWithMarginAndMrps.map(
                                        (product) => {

                                            let editRowData =
                                                editData.stockStakeHolderOrderDetails.find(
                                                    (row) => row.product.id == product.products.id
                                                );
                                            return {
                                                ...product,
                                                uomConversionValue: product.products.uomConversionValue,
                                                qty:
                                                    Object.keys(editRowData).length !== 0 ? editRowData.qty : "",
                                                freeQty: 0,
                                                itemDiscPer: 0,
                                                //Hide Stock - By Tejas (Om saai) 20/11/2025
                                                // productStock: (
                                                //     product.productFromOrderStockForMobile.secondaryClosingQty /
                                                //     product.products.uomConversionValue
                                                // ).toFixed(2),
                                                total: (Object.keys(editRowData).length
                                                    ? +editRowData.qty * +product.rate
                                                    : 0
                                                ).toFixed(2),
                                                stockError: 0,
                                            };
                                        }
                                    ),
                                };
                            });
                            this.setCatList({ row });
                        }
                    } else {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });

                showLoador({ loador: false });

            }
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };


    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
        });
    };
    submitHandler = () => {
        if (this.checkValidationOnSubmit()) {
            const { category } = this.props;
            let rowList = [];
            category.category.map((catData) => {
                if (catData.flag == 3) {
                    const filterData = catData.productWithMarginAndMrps.filter(
                        (row) => row.qty != 0
                    );
                    rowList = [...rowList, ...filterData];
                    return catData;
                }
            });
            if (rowList.length != 0) {
                this.setState({
                    orderList: rowList.map((rowData, index) => {
                        return {
                            index: index + 1,
                            id: rowData.id,
                            product: rowData.products !== null ? rowData.products : "",
                            subCategory:
                                rowData.products !== null &&
                                    rowData.products.group !== null &&
                                    rowData.products.group.subCategory !== null &&
                                    rowData.products.group.subCategory.id
                                    ? rowData.products.group.subCategory.id
                                    : "",
                            category:
                                rowData.products !== null &&
                                    rowData.products.group !== null &&
                                    rowData.products.group.subCategory !== null &&
                                    rowData.products.group.subCategory.category !== null &&
                                    rowData.products.group.subCategory.category.id
                                    ? rowData.products.group.subCategory.category.id
                                    : "",
                            categoryName:
                                rowData.products !== null &&
                                    rowData.products.group !== null &&
                                    rowData.products.group.subCategory !== null &&
                                    rowData.products.group.subCategory.category !== null &&
                                    rowData.products.group.subCategory.category.name
                                    ? rowData.products.group.subCategory.category.name
                                    : "",
                            categoryShortName:
                                rowData.products !== null &&
                                    rowData.products.group !== null &&
                                    rowData.products.group.subCategory !== null &&
                                    rowData.products.group.subCategory.category !== null &&
                                    rowData.products.group.subCategory.category.shortName
                                    ? rowData.products.group.subCategory.category.shortName
                                    : "",
                            categorySortOrder:
                                rowData.products !== null &&
                                    rowData.products.group !== null &&
                                    rowData.products.group.subCategory !== null &&
                                    rowData.products.group.subCategory.category !== null &&
                                    rowData.products.group.subCategory.category.sortOrder
                                    ? rowData.products.group.subCategory.category.sortOrder
                                    : "",
                            isActive:
                                rowData.products !== null &&
                                    rowData.products.group !== null &&
                                    rowData.products.group.subCategory !== null &&
                                    rowData.products.group.subCategory.category !== null &&
                                    rowData.products.group.subCategory.category.isActive
                                    ? rowData.products.group.subCategory.category.isActive
                                    : "",
                            insertDateTime:
                                rowData.products !== null &&
                                    rowData.products.group !== null &&
                                    rowData.products.group.subCategory !== null &&
                                    rowData.products.group.subCategory.category !== null &&
                                    rowData.products.group.subCategory.category.insertDateTime
                                    ? rowData.products.group.subCategory.category.insertDateTime
                                    : "",

                            taxPercentage:
                                rowData.products !== null &&
                                    rowData.products.taxPercentage !== null &&
                                    rowData.products.taxPercentage.id
                                    ? rowData.products.taxPercentage.id
                                    : "",
                            taxName:
                                rowData.products !== null &&
                                    rowData.products.taxPercentage !== null &&
                                    rowData.products.taxPercentage.name
                                    ? rowData.products.taxPercentage.name
                                    : "",
                            taxSgst:
                                rowData.products !== null &&
                                    rowData.products.taxPercentage !== null &&
                                    rowData.products.taxPercentage.sgst
                                    ? rowData.products.taxPercentage.sgst
                                    : "",
                            taxCgst:
                                rowData.products !== null &&
                                    rowData.products.taxPercentage !== null &&
                                    rowData.products.taxPercentage.cgst
                                    ? rowData.products.taxPercentage.cgst
                                    : "",
                            taxIgst:
                                rowData.products !== null &&
                                    rowData.products.taxPercentage !== null &&
                                    rowData.products.taxPercentage.igst
                                    ? rowData.products.taxPercentage.igst
                                    : "",
                            taxCess:
                                rowData.products !== null &&
                                    rowData.products.taxPercentage !== null &&
                                    rowData.products.taxPercentage.cess
                                    ? rowData.products.taxPercentage.cess
                                    : "",
                            hsnCode:
                                rowData.products !== null &&
                                    rowData.products.taxPercentage !== null &&
                                    rowData.products.taxPercentage.hsnCode
                                    ? rowData.products.taxPercentage.hsnCode
                                    : "",
                            taxInsertDateTime:
                                rowData.products !== null &&
                                    rowData.products.taxPercentage !== null &&
                                    rowData.products.taxPercentage.insertDateTime
                                    ? rowData.products.taxPercentage.insertDateTime
                                    : "",
                            stakeHolderUom:
                                rowData.products !== null &&
                                    rowData.products.stakeHolderUom !== null &&
                                    rowData.products.stakeHolderUom.id
                                    ? rowData.products.stakeHolderUom.id
                                    : "",
                            stakeHolderUom:
                                rowData.products !== null &&
                                    rowData.products.stakeHolderUom !== null &&
                                    rowData.products.stakeHolderUom.id
                                    ? rowData.products.stakeHolderUom.id
                                    : "",
                            productName:
                                rowData.products !== null && rowData.products.name
                                    ? rowData.products.name
                                    : "",
                            outletName:
                                rowData.products !== null &&
                                    rowData.products.stakeHolderUom !== null &&
                                    rowData.products.stakeHolderUom.name
                                    ? rowData.products.stakeHolderUom.name
                                    : "",
                            outletisActive:
                                rowData.products !== null &&
                                    rowData.products.stakeHolderUom !== null &&
                                    rowData.products.stakeHolderUom.isActive
                                    ? rowData.products.stakeHolderUom.isActive
                                    : "",
                            outletInsertDateTime:
                                rowData.products !== null &&
                                    rowData.products.stakeHolderUom !== null &&
                                    rowData.products.stakeHolderUom.insertDateTime
                                    ? rowData.products.stakeHolderUom.insertDateTime
                                    : "",
                            outletUom:
                                rowData.products !== null &&
                                    rowData.products.outletUom !== null &&
                                    rowData.products.outletUom.id
                                    ? rowData.products.outletUom.id
                                    : "",
                            outletUomName:
                                rowData.products !== null &&
                                    rowData.products.outletUom !== null &&
                                    rowData.products.outletUom.name
                                    ? rowData.products.outletUom.name
                                    : "",
                            outletUomIsActive:
                                rowData.products !== null &&
                                    rowData.products.outletUom !== null &&
                                    rowData.products.outletUom.isActive
                                    ? rowData.products.outletUom.isActive
                                    : "",
                            outletUomInsertDateTime:
                                rowData.products !== null &&
                                    rowData.products.outletUom !== null &&
                                    rowData.products.outletUom.insertDateTime
                                    ? rowData.products.outletUom.insertDateTime
                                    : "",
                            uomConversionValue:
                                rowData.products !== null && rowData.products.uomConversionValue
                                    ? rowData.products.uomConversionValue
                                    : 0,
                            productCode:
                                rowData.products !== null && rowData.products.code
                                    ? rowData.products.code
                                    : "",

                            shortName:
                                rowData.products !== null && rowData.products.shortName
                                    ? rowData.products.shortName
                                    : "",
                            weight:
                                rowData.products !== null && rowData.products.weight
                                    ? rowData.products.weight
                                    : "",
                            description:
                                rowData.products !== null && rowData.products.description
                                    ? rowData.products.description
                                    : "",
                            selfLife:
                                rowData.products !== null && rowData.products.selfLife
                                    ? rowData.products.selfLife
                                    : "",
                            image:
                                rowData.products !== null && rowData.products.image
                                    ? rowData.products.image
                                    : "",
                            sortOrder:
                                rowData.products !== null && rowData.products.sortOrder
                                    ? rowData.products.sortOrder
                                    : "",
                            isActive:
                                rowData.products !== null && rowData.products.isActive
                                    ? rowData.products.isActive
                                    : "",
                            insertDateTime:
                                rowData.products !== null && rowData.products.insertDateTime
                                    ? rowData.products.insertDateTime
                                    : "",

                            mrp:
                                rowData.products !== null && rowData.products.mrp
                                    ? rowData.products.mrp
                                    : "",
                            marginPercentage:
                                rowData.marginPercentage !== null
                                    ? (+rowData.marginPercentage).toFixed(2)
                                    : 0,
                            mrp: rowData.mrp !== null ? (+rowData.mrp).toFixed(2) : 0,

                            qty: rowData.qty !== null ? rowData.qty : 0,
                            rate: rowData.rate !== null ? (+rowData.rate).toFixed(2) : 0,
                            total: rowData.total,
                        };
                    }),
                });
                this.toggle();
            } else {
                this.props.showNotification({ msg: atleastOne, severity: "error" });
            }
        }
    };
    checkValidationOnSubmit = () => {
        const { fieldData } = this.state;
        const mandatoryCheckErrors = mandatoryCheck({
            fieldData,
            fieldMeta: ApprovePendingOrderJson.fieldMeta,
        });
        this.setState({
            formErrors: mandatoryCheckErrors.formErrors,
        });
        if (mandatoryCheckErrors.formValid) {
            const ValidationCheckErrors = ValidationCheck({
                fieldData,
                fieldMeta: ApprovePendingOrderJson.fieldMeta,
            });
            this.setState({
                formErrors: ValidationCheckErrors.formErrors,
            });
            return ValidationCheckErrors.formValid;
        } else {
            return false;
        }
    };
    getOrder = () => {
        const { orderList, headerData, fieldData, remark } = this.state;
        const outletBillDetails = orderList.map((orderData) => {
            let editData = headerData.stockStakeHolderOrderDetails.find(
                (row) => row.product.id == orderData.product.id
            );
            if (Object.keys(editData).length !== 0) {
                return {
                    ...orderData,
                    id: editData.id,
                    uom: {
                        id: orderData.outletUom,
                    },
                    inserteUserId: headerData.insertedUserId,
                    product: orderData.product,
                    qty: orderData.qty,
                };
            } else {
                return {
                    ...orderData,
                    uom: {
                        id: orderData.outletUom,
                    },
                    inserteUserId: headerData.insertedUserId,
                    product: orderData.product,
                    qty: orderData.qty,
                };
            }
        });
        const dataToSave = {
            ...headerData,
            discountOnBillPer: fieldData.DiscountPercentage
                ? fieldData.DiscountPercentage
                : 0,
            stockStakeHolderOrderDetails: outletBillDetails,
            remark: remark,
        };
        swal({
            title: "Are you sure?",
            text: updateData,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                this.onSave(dataToSave);
            }
        });
    };

    onSave = async (beatNewObjectToSave) => {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            this.toggle();
            showLoador({ loador: true });
            await apiPost({
                url: endpoint.stockStakeholderOrderHeader + "/edite",
                postBody: beatNewObjectToSave,
            }).then(({ data, success }) => {
                if (success) {
                    showNotification({ msg: savemsg });
                    this.props.navigate("/received-order-page");
                } else {
                    showNotification({ msg: saveFailedMsg, severity: "error" });
                }
                return success;
            });
            showLoador({ loador: false });

        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };
    onCancel = () => {
        this.props.navigate(-1);
    };
    setListDetails = ({ row }) => {
        const { orderHeaderList, setOrderList } = this.props;

        let data = {
            ...orderHeaderList.placeOrderList,
            stockStakeHolderOrderDetails: row,
        };

        setOrderList({ row: data });
    };
    onDataChange = (fieldName, newValue) => {
        if (fieldName == "DiscountPercentage") {
            let discountAmt = (this.state.total * +newValue) / 100;
            this.setState({
                totalAmt: +this.state.total - +discountAmt,
            });
        }
        const { fieldData } = this.state;
        const dataToSearch = {};
        const dataToReset = { ...this.state.fieldData };
        let listError = false;
        ApprovePendingOrderJson.fieldMeta.map((currentField) => {
            if (currentField.getDate && currentField.dataKey === fieldName) {
                dataToReset[currentField.getDate] = newValue.add(365, "day");
            }
            if (currentField.dataKey === fieldName && currentField.getListId) {
                const masterKeyList = currentField.getListId.split(",");
                masterKeyList.map((key) => {
                    if (fieldName === key) {
                        dataToSearch[key] = newValue;
                    } else if (fieldData[key]) {
                        dataToSearch[key] = fieldData[key];
                    }
                    return null;
                });
            }
            if (currentField.getListFrom) {
                const masterKeyList = currentField.getListFrom.split(",");
                masterKeyList.map((key) => {
                    if (key == fieldName && dataToReset[key]) {
                        delete dataToReset[currentField.dataKey];
                    }
                });
            }
            if (
                !listError &&
                fieldData[currentField.dataKey] &&
                currentField.controlType != "datepicker" &&
                currentField.getListFrom == undefined
            ) {
                dataToReset[currentField.dataKey] = fieldData[currentField.dataKey];
            }
            return null;
        });

        dataToReset[fieldName] = newValue;
        this.setState({
            fieldData: dataToReset,
        });
    };
    toggle = () => {
        this.setState({
            open: !this.state.open,
        });
    };

    changeHandler = (e) => {
        const { name, value } = e.target;
        if (name === "remark") {
            this.setState({ remark: value });
        }
    };

    onSearch = (searchValue) => {
        this.setState({
            searchValue: searchValue,
        });
    };
    getFilteredTableData = (tableData) => {
        const { searchValue } = this.state;
        return tableData.filter((currentRow) => {
            let isValid = false;
            let productName =
                currentRow.products != null ? currentRow.products.name : "-";
            let stakeHolderUom =
                currentRow.products.stakeHolderUom != null
                    ? currentRow.products.stakeHolderUom.name
                    : "-";
            let rate = currentRow.rate != null ? currentRow.rate : "-";
            let qty = currentRow.qty != null ? currentRow.qty : "-";
            if (
                productName &&
                productName.toLowerCase().includes(searchValue.toLowerCase())
            ) {
                isValid = true;
                return true;
            }
            if (
                stakeHolderUom &&
                stakeHolderUom.toLowerCase().includes(searchValue.toLowerCase())
            ) {
                isValid = true;
                return true;
            }
            if (rate && rate.toLowerCase().includes(searchValue.toLowerCase())) {
                isValid = true;
                return true;
            }
            return isValid;
        });
    };
    render() {
        const {
            dynamicMasterData,
            DataToSet,
            value,
            total,
            qty,
            totalAmt,
            open,
            orderList,
            formErrors,
            remark,
            fieldData,
            creditLimit,
            flag,
        } = this.state;
        const { category } = this.props;
        return (
            <>
                <Paper
                    sx={{
                        p: 2,
                        borderRadius: 2,
                    }}
                    elevation={0}
                >
                    <DynamicFormWithoutValidation
                        showBackToList={true}
                        getListById={this.getListById}
                        dynamicMasterData={dynamicMasterData}
                        showTitle={ApprovePendingOrderJson.showTitle}
                        screenTitle={ApprovePendingOrderJson.screenTitle}
                        fieldMeta={ApprovePendingOrderJson.fieldMeta}
                        apiBaseURL={ApprovePendingOrderJson.apiBaseURL}
                        formErrors={formErrors}
                        showSaveBtn={ApprovePendingOrderJson.showSaveBtn}
                        showSaveBtnMain={false}
                        fieldData={fieldData}
                        onDataChange={this.onDataChange}
                        DataToSet={DataToSet}
                    />

                    {category.category.length != 0 && (
                        <>
                            <Tabs
                                value={value}
                                onChange={this.handleChange}
                                variant="scrollable"
                                scrollButtons
                                allowScrollButtonsMobile
                                aria-label="scrollable force tabs example"
                            >
                                {category.category.map((catData) => {
                                    return (
                                        <Tab
                                            label={
                                                catData.category.name +
                                                " ( " +
                                                catData.productWithMarginAndMrps.length +
                                                " )"
                                            }
                                        />
                                    );
                                })}
                            </Tabs>
                            {category.category.map((catData, index) => {
                                return (
                                    <TabPanel value={value} index={index}>
                                        <LandingScreenHeader
                                            screenTitle={""}
                                            showSearchBox={true}
                                            showTable={true}
                                            showFilter={false}
                                            showPdfDownload={false}
                                            showExcelDownload={false}
                                            onSearch={this.onSearch}
                                        />
                                        <OrderTable
                                            total={total}
                                            qty={qty}
                                            tableHead={
                                                flag
                                                    ?
                                                    [
                                                        {
                                                            title: "Sr.No.",
                                                            name: "index",
                                                            positionCenter: false,
                                                            showInscreen: true,
                                                            alignCenter: "center",
                                                        },
                                                        {
                                                            title: "Product Name",
                                                            name: "name",
                                                            positionCenter: false,
                                                            showInscreen: true,
                                                            alignCenter: "left",
                                                        },
                                                        {
                                                            title: "UOM",
                                                            name: "name",
                                                            positionCenter: true,
                                                            showInscreen: true,
                                                        },
                                                        {
                                                            title: "Rate",
                                                            name: "name",
                                                            positionCenter: false,
                                                            showInscreen: true,
                                                            alignCenter: "left",
                                                        },
                                                        // {
                                                        //     title: "Product Stock",
                                                        //     name: "name",
                                                        //     positionCenter: false,
                                                        //     showInscreen: true,
                                                        //     alignCenter: "left",
                                                        // },
                                                        {
                                                            title: "Quantity",
                                                            name: "target",
                                                            placeHolder: "Enter Target",
                                                            textFieldError: "targetErr",
                                                            positionCenter: false,
                                                            showInscreen: true,
                                                        },
                                                        {
                                                            title: "Total",
                                                            name: "name",
                                                            positionCenter: false,
                                                            showInscreen: true,
                                                            alignCenter: "left",
                                                        },
                                                    ] :
                                                    [
                                                        {
                                                            title: "Sr.No.",
                                                            name: "index",
                                                            positionCenter: false,
                                                            showInscreen: true,
                                                            alignCenter: "center",
                                                        },
                                                        {
                                                            title: "Product Name",
                                                            name: "name",
                                                            positionCenter: false,
                                                            showInscreen: true,
                                                            alignCenter: "left",
                                                        },
                                                        {
                                                            title: "UOM",
                                                            name: "name",
                                                            positionCenter: true,
                                                            showInscreen: true,
                                                        },
                                                        {
                                                            title: "Rate",
                                                            name: "name",
                                                            positionCenter: false,
                                                            showInscreen: true,
                                                            alignCenter: "left",
                                                        },
                                                        {
                                                            title: "Quantity",
                                                            name: "target",
                                                            placeHolder: "Enter Target",
                                                            textFieldError: "targetErr",
                                                            positionCenter: false,
                                                            showInscreen: true,
                                                        },
                                                        {
                                                            title: "Total",
                                                            name: "name",
                                                            positionCenter: false,
                                                            showInscreen: true,
                                                            alignCenter: "left",
                                                        },
                                                    ]}
                                            data={this.getFilteredTableData(
                                                catData.productWithMarginAndMrps
                                            )}
                                            rowList={category.category}
                                            setList={this.setCatList}
                                            flag={flag}

                                        />
                                    </TabPanel>
                                );
                            })}
                            <br />
                            <DynamicDetails
                                DataToSet={[
                                    {
                                        xs: 12,
                                        sm: 6,
                                        md: 6,
                                        lg: 6,
                                        label: "Credit Limit",
                                        value: creditLimit,
                                    },
                                    {
                                        xs: 12,
                                        sm: 6,
                                        md: 6,
                                        lg: 6,
                                        label: "Total Amount",
                                        value: total.toFixed(2),
                                    },
                                    {
                                        xs: 12,
                                        sm: 6,
                                        md: 6,
                                        lg: 6,
                                        label: "Total Quantity",
                                        value: qty,
                                    },
                                    {
                                        xs: 12,
                                        sm: 6,
                                        md: 6,
                                        lg: 6,
                                        label: "Balance",
                                        value: creditLimit - +total.toFixed(2),
                                    },
                                ]}
                            />
                            <Grid container alignItems="center">
                                <Grid item xs={12} md={2.5} sm={2.5}>
                                    <LabelCompo
                                        className="text-black"
                                        style={{ fontSize: 16, color: titleColor, marginLeft: 15 }}
                                        label=" Add Comment :"
                                    />
                                </Grid>
                                <Grid item xs={12} md={9.5} sm={9.5}>
                                    <TextFieldCompo
                                        placeholder="Add Comment"
                                        color="primary"
                                        name="remark"
                                        size="small"
                                        value={remark}
                                        fullWidth
                                        onChange={this.changeHandler}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid
                                    container
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    sx={{ justifyContent: "flex-end" }}
                                >
                                    <ButtonCompo
                                        size="medium"
                                        type="submit"
                                        variant="contained"
                                        name={"Proceed"}
                                        onClick={this.submitHandler}
                                    />
                                </Grid>
                            </Grid>
                        </>
                    )}
                </Paper>
                {open && (
                    <EditOrderPopUp
                        formData={{
                            total: total,
                            qty: qty,
                            discount: fieldData.DiscountPercentage
                                ? fieldData.DiscountPercentage
                                : 0,
                            totalAmt: totalAmt,
                        }}
                        columns={[
                            {
                                title: "Sr. No.",
                                name: "index",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "center",
                            },
                            {
                                title: "Product Name",
                                name: "productName",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "left",
                                canSearch: true,
                            },
                            {
                                title: "UOM",
                                name: "outletName",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "center",
                                canSearch: true,
                            },

                            {
                                title: "Quantity",
                                name: "qty",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "right",
                                canSearch: true,
                            },

                            {
                                title: "Rate",
                                name: "rate",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "right",
                                canSearch: true,
                            },
                            {
                                title: "Total",
                                name: "total",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "right",
                                canSearch: true,
                            },
                        ]}
                        open={open}
                        handleCloses={this.toggle}
                        rows={orderList}
                        getOrder={this.getOrder}
                    />
                )}
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    orderHeaderList: state.orderHeaderList,
    category: state.category,
});
const mapDispatchToProps = {
    showNotification,
    showLoador,
    getPlaceOrderHeaderById,
    setOrderList,
    setCategoryAndItem,
    getCreditLimitByStockHolderId,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(ApprovalPendingOrderEdit);
